module.exports = __webpack_public_path__ + "img/phone-call.5b0cf183.jpg";